import { Delete, MenuOutlined } from '@mui/icons-material';
import {
  Button as AntdButton,
  Button,
  Col,
  Dropdown,
  Row,
  Skeleton,
  Space
} from "antd";
import Loading from "components/Loading";
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { useMobileDetect, useTabletDetection } from "containers/chat/hooks";
import React, { useMemo, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import styled from "styled-components";
import color from "utils/constants/color";
import {
  addPrintableClass,
  removePrintableClass,
} from "utils/methods/textMethod";
import ArticleViewAdmin from "./ArticleView";

const LessonContainer = styled.section`
  background: transparent;
  width: 100%;
  height: 100%;
`;

const LessonModal = styled.div`
  background: #000f4c;
  padding-left: ${(p) => (p.view ? "15px" : "15px")};
  padding-right: ${(p) => (p.view ? "15px" : "15px")};
  padding-bottom: ${(p) => (p.view ? "15px" : "26px")};
  padding-top: ${(p) => (p.view ? "20px" : "17px")};
  height: ${(p) => (p.view ? "80vh" : "100%")};
  overflow: hidden scroll;
  // overflow: hidden auto;
  @media Screen and (max-width: 600px){
    height:110% !important;
  }
  @media Screen and (min-width:801px) and (max-width: 830px){
    height:120% !important;
  }
`;

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: row;
`;

const BoxContainer = styled.div`
  display: flex;

  align-items: center;
  gap: 12px;
`;

const Label = styled.label`
  color: #fff;
  // font-family: "Gotham";
  font-size: 14px;
  font-weight: 400;
  // font-family: Gotham;
  white-space: nowrap;
  @media (max-width: 768px) {
    color: #fff;
    font-size: 13px;
     
    font-weight: 400;
  }
`;

const FieldShareBox = styled.div`
  display: grid;
  place-items: center;
  border-radius: 9.5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  text-align: center;
  min-width: 63px;

  width: 100%;
  height: 31px;
  color: #000;
  // font-family: Gotham;
  font-size: 12px;
   
  font-weight: 400;
  flex: 1;
  @media (max-width: 768px) {
    color: #000;
    // font-family: "Gotham";
    font-size: 10px;
     
    font-weight: 400;
  }
    .ant-select-selection-item{
      text-align:left;
    }
`;

const DeleteIcon = styled(Delete)`
    font-size: 18;
    cursor: pointer;
    color: red;
    margin-left:auto;
`;

const LevelButton = styled(AntdButton)`
  background-color: ${({ active }) => (active ? color.orange200 : '#fff')};
  color: ${({ active }) => (active ? 'white' : 'black')};
  border: none;
  border-radius: 8px;
  cursor: pointer;

  // Disable Antd default hover/focus effects
  &:focus,
  &:hover,
  &:active {
    background-color: ${({ active }) => (active ?  color.orange200  : '#fff')} !important;
    color: ${({ active }) => (active ? 'white' : 'black')} !important;
    box-shadow: none !important;
    border: none !important;
  }
`;
const ListLevelButton = styled(Button)`
   background-color:rgb(3, 152, 158);
  color:white;
  border: none;
  border-radius: 10px;
  cursor: pointer;

  // Disable Antd default hover/focus effects
  &:focus,
  &:hover,
  &:active {
  background-color:rgb(3, 152, 158);
  color:white;
    box-shadow: none !important;
    border: none !important;
  }
`;
const LevelItemList = styled.div`
   background-color: ${({ active }) => (active ? 'rgb(3, 152, 158)' : '#fff')};
  color: ${({ active }) => (active ? 'white' : 'black')};
  border: none;
  border-radius: 2px;
  cursor: pointer;

  // Disable Antd default hover/focus effects
  &:focus,
  &:hover,
  &:active {
    background-color: ${({ active }) => (active ? 'rgb(3, 152, 158)' : '#fff')} !important;
    color: ${({ active }) => (active ? 'white' : 'black')} !important;
    box-shadow: none !important;
    border: none !important;
  }
`;
const levelOrder = ["Intermediate-low", "Intermediate-mid", "Intermediate-high"];

const ViewArticleLevels = ({
  selectedArticle,
  setSelectedArticle,
  page_articles,
  onGenerateMore=()=>{},
  onDeleteArticles=()=>{},
  deleteLoader,
  articleLevelTitle,
  articleLevelText
}) => {
  const showAlert = useAlert();
  const imageRef = useRef();
  const formattePageArticledData = useMemo(() => {
    return page_articles.map((item) => ({value: item.id,label: item.articles_title,profency_level: item.config?.proficiencyLevel , pages: item.config?.pages})).sort((a, b) => {
      const indexA = levelOrder.indexOf(a.profency_level);
      const indexB = levelOrder.indexOf(b.profency_level);
      return indexA - indexB;
    });
  }, [page_articles]);
  const [printLoader, setPrintloader] = useState(false);
  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;
  const width = window.innerWidth;
  const isCompact = width <= 500 || (width >= 809 && width <= 890);

  const selectedProficiencyLevel = useMemo(() => {
    if (selectedArticle) {
      return selectedArticle?.config?.proficiencyLevel
    } else if (Array.isArray(formattePageArticledData) && formattePageArticledData?.length > 0) {
      return formattePageArticledData[0].profency_level
    } return null;
  }, [selectedArticle, formattePageArticledData])

  const handleClickActive = (level) => {
    const currentLevel = level?.profency_level
    onSelectAricle(level?.value)
  };
  const formatProficiencyLevel = (level) => {
    switch (level) {
      case 'Intermediate-low':
        return 'Intermediate Low';
      case 'Intermediate-mid':
        return  'Intermediate Mid';
      case 'Intermediate-high':
        return 'Intermediate High';
      default:
        return level;
    }
  };

  const validationPrint = () => {
    if (isMobile || isTablate) {
      showAlert("Print is not supported on this device!","error");
      return;
    } else {
      addPrintableClass();
      printCall();
    }
  };
  const printCall = useReactToPrint({
    contentRef: imageRef,
    onBeforeGetContent: async () => {
      setPrintloader(true);
    },
    onBeforePrint: async () => {
      setPrintloader(false);
    },
    onAfterPrint: async () => {
      removePrintableClass();
    },
  });



  const onSelectAricle = (value) => {
        const article = page_articles?.find((story) => story.id === value);
        setSelectedArticle(article);
   }

   const updateArticle = (data) => {
     setSelectedArticle(data);
   }
 
  const RenderMenuContent = () => {
    return formattePageArticledData.map((item) => ({
      key: item.value,
      label: (
        <LevelItemList
          active={selectedProficiencyLevel === item.profency_level}
          className="ulLitItmeList"
          onClick={() => handleClickActive(item)}
        >
          {formatProficiencyLevel(item?.profency_level)}
        </LevelItemList>
      ),
    }));
  };
  return (
    <>
        <LessonContainer>
          <LessonModal
            style={{ position: "relative" }}
            view
          >
            {(articleLevelTitle || articleLevelText) ? (
              <Skeleton active paragraph={{ rows: 4 }} title={false} />
            ) : (
            <Container>
              <div className={"widthStoryCont"} style={{ width:"98%"}}>
              <BoxContainer
                  style={{
                    marginRight: 6,
                    marginBottom: 12,
                    width: "100%",
                  }}
                >
                  {/* <Label style={{position:'absolute',top:13,zIndex:9}}>Levels</Label> */}
                  <div
                    style={{ cursor: "pointer" }}
                    onClick={onGenerateMore}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "white",
                          cursor: "pointer",
                          backgroundColor: "#03989e"}}
                      >
                        {"Generate Levels"}
                      </AntdButton>
                    </span>
                  </div>
                  {/* <div
                    style={{ cursor: "pointer", width: "50px" }}
                    onClick={() => {
                      validationPrint();
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        className="share-button-super-lesson"
                        // type="primary"
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "black",
                          backgroundColor:"#03989e"
                        }}
                      >
                        {printLoader ? <Loading size={20} /> : <PrintIcon style={{ color: 'white' }} />}
                      </AntdButton>
                    </span>
                </div> */}
                {isCompact && (
                  <Dropdown menu={{ items: RenderMenuContent() }} trigger={['click']}>
                    <ListLevelButton style={{ display: 'flex', alignItems: 'center' }} className="levelListBtn">
                      <MenuOutlined />
                    </ListLevelButton>
                  </Dropdown>
                )}
                  <div
                    style={{ cursor: "pointer", width: "50px" }}
                    onClick={() => {
                      onDeleteArticles()
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                      }}
                    >
                      <AntdButton
                        className="share-button-super-lesson"
                        // type="primary"
                        style={{
                          borderRadius: 10,
                          border: "0px",
                          color: "black",
                          backgroundColor:"red"
                        }}
                      >
                        {deleteLoader ? <Loading size={20} /> : <DeleteIcon style={{ color: 'white' }} />}
                      </AntdButton>
                    </span>
                  </div>
                </BoxContainer>
                <BoxContainer
                  style={{
                    marginRight: 6,
                    // marginLeft: 13,
                    marginBottom: 12,
                    position:'relative'
                  }}
              >
                {!isCompact &&
                  <Row
                    style={{
                      width: '100%',
                    }}
                  >
                    <Col span={24}
                      lg={12}
                      sm={24}
                      xs={24} >
                      <FieldShareBox
                        style={{
                          background: "none",
                          flex: "1",
                          border: "none",
                          placeItems: "start",
                        }}
                      >
                        <Space direction="horizontal" style={{ width: "100%" }}>
                          {formattePageArticledData.map((item) => <LevelButton key={item.value}
                            active={selectedProficiencyLevel === item.profency_level}
                            onClick={() => handleClickActive(item)}>
                            {formatProficiencyLevel(item?.profency_level)}
                          </LevelButton>)}
                        </Space>
                      </FieldShareBox>
                    </Col>
                  </Row>
                }
                </BoxContainer>
              </div>
            </Container>
            )}
            <ArticleViewAdmin
              ref={imageRef} 
              images={selectedArticle?.images  || []}
              text={articleLevelText ? articleLevelText : selectedArticle ? selectedArticle?.articles_text : ""}
              title={articleLevelTitle ? articleLevelTitle : selectedArticle?.articles_title || ''}
              storyInfo={selectedArticle|| {}}
              updateStoryInfo={updateArticle}
              />
          </LessonModal>
        </LessonContainer>
    </>
  );
};

export default ViewArticleLevels;
